/*
 * central place to import env vars and add default value to them
 */

export const KeycloakInfo = import.meta.env.VITE_KEYCLOAK_INFO
	? JSON.parse(import.meta.env.VITE_KEYCLOAK_INFO)
	: {
			realm: 'zdb',
			url: 'http://localhost/auth/',
			'ssl-required': 'none',
			resource: 'zdb',
			'public-client': true,
			'confidential-port': 0,
			clientId: 'zdb',
		};

export const DOMAIN: string = import.meta.env.VITE_DOMAIN || 'oxs';
export const BaseUrl: string = import.meta.env.VITE_BASE_URL || 'http://localhost/oxs/';
export const BasePath: string = import.meta.env.VITE_BASE_PATH || '/';
export const LogUrl: string = import.meta.env.VITE_APP_LOG_URL || 'http://localhost/csp/';
export const IsLive: boolean = BaseUrl.includes('api.fibl-services.org');
export const IsDev: boolean = BaseUrl.includes('localhost');
export const CommitSha = import.meta.env.VITE_APP_COMMIT_SHA || 'dev';
export const ETrackerCode = import.meta.env.VITE_APP_ETRACKER || '';
export const LogRocketCode = import.meta.env.VITE_APP_LOGROCKET || '';
export const DomainConfig: Record<string, string> = import.meta.env.VITE_DOMAIN_CONF
	? JSON.parse(import.meta.env.VITE_DOMAIN_CONF)
	: { 'localhost/': 'ADM' };

console.log('ENV', { KeycloakInfo, DOMAIN, BaseUrl, BasePath, LogUrl, IsLive, IsDev });
